import {
  cellRenderParseData, cellSORenderStatus
} from '../../utils/functions';

const columnDataGrid = [
  {
    dataField: 'salesOrderNum',
    caption: '№ заказа',
    dataType: 'string'
  },
  {
    dataField: 'salesOrderSystemNum',
    caption: '№ заказа системный',
    dataType: 'string'
  },
  {
    dataField: 'salesOrderLineNum',
    caption: '№ позиции',
    dataType: 'string'
  },
  {
    dataField: 'statusName',
    caption: 'Статус',
    dataType: 'string',
    cellRender: cellSORenderStatus
  },
  {
    dataField: 'customer',
    caption: 'Заказчик',
    dataType: 'string'
  },
  {
    dataField: 'salesOrderLineMaxCapacity',
    caption: 'Количество ГП (максимальное)',
    dataType: 'string'
  },
  {
    dataField: 'salesOrderLineCurrentCapacity',
    caption: 'Количество привязанной ГП (текущее)',
    dataType: 'string'
  },
  {
    dataField: 'salesOrderLineNominalCapacity',
    caption: 'Количество ГП (номинальное)',
    dataType: 'string'
  },
  {
    dataField: 'salesOrderLineMinCapacity',
    caption: 'Количество ГП (минимальное)',
    dataType: 'string'
  },
  {
    dataField: 'salesOrderLineRemainsCapacity',
    caption: 'Доступно к привязке (остаток)',
    dataType: 'string'
  },
  {
    dataField: 'createDate',
    caption: 'Дата создания',
    dataType: 'date',
    cellRender: cellRenderParseData
  },
  {
    dataField: 'conditionOfShipmentName',
    caption: 'Условие отгрузки',
    dataType: 'string'
  },
  {
    dataField: 'specDate',
    caption: 'Дата спецификации',
    dataType: 'date',
    cellRender: cellRenderParseData
  },
  {
    dataField: 'depositor',
    caption: 'Грузотправитель (Продавец) наименование краткое',
    dataType: 'string'
  },
  {
    dataField: 'consignee',
    caption: 'Грузополучатель',
    dataType: 'string'
  },
  {
    dataField: 'shiptoStationCodeSo',
    caption: 'Станция назначения',
    dataType: 'string'
  },
  {
    dataField: 'shiptoStationNameSo',
    caption: 'Наименование станции назначения',
    dataType: 'string'
  },
  {
    dataField: 'shiptoRailwayCodeSo',
    caption: 'Железно-дорожное транспортное агентство',
    dataType: 'string'
  },
  {
    dataField: 'shiptoRailwayNameSo',
    caption: 'Наименование железной дороги',
    dataType: 'string'
  },
  {
    dataField: 'reasonForTheBan',
    caption: 'Причина запрета',
    dataType: 'string'
  },
  {
    dataField: 'sortingType',
    caption: 'Вид отсортировки',
    dataType: 'string'
  },
  {
    dataField: 'salesOrderLineName',
    caption: 'Материал',
    dataType: 'string'
  }
];

export default columnDataGrid;
